import { type CapabilityAccessView, CLIENT_OPERATING_CONTEXT_HEADER } from "@solomon-apps/shared";

import { orgApiFetch, orgApiFetchResponse } from "./orgApiFetch";

export function fetchClientCapabilityAccess(): Promise<CapabilityAccessView> {
    return orgApiFetch<CapabilityAccessView>("/api/org/client/capability-access");
}

export async function fetchClientCapabilityAccessResource(
    relationshipUuid: string
): Promise<{ access: CapabilityAccessView; etag: string }> {
    const response = await orgApiFetchResponse("/api/org/client/capability-access", {
        headers: {
            [CLIENT_OPERATING_CONTEXT_HEADER]: relationshipUuid
        }
    });
    const access = (await response.json()) as CapabilityAccessView;
    const etag = response.headers.get("ETag");
    if (!etag) throw new Error("Capability access response did not include an ETag");
    return { access, etag };
}

export async function fetchClientAgreementDocument(input: {
    requirementUuid: string;
    kind: "signed-document" | "completion-certificate";
}): Promise<{ blob: Blob; filename: string }> {
    const response = await orgApiFetchResponse(
        `/api/org/client/capability-agreements/${input.requirementUuid}/documents/${input.kind}`
    );
    const blob = await response.blob();
    const disposition = response.headers.get("Content-Disposition") ?? "";
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    return {
        blob,
        filename:
            match?.[1] ?? (input.kind === "signed-document" ? "signed-agreement.pdf" : "completion-certificate.pdf")
    };
}
